module.exports = __webpack_public_path__ + "assets/img/lifelist.ebe9ea41.png";